import styled, { css } from 'styled-components';
import { MHighlightNumericAlignment } from './MHighlightNumeric.types';

export const Wrapper = styled.div<{
  alignment: MHighlightNumericAlignment;
}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${({ alignment }) =>
    alignment === MHighlightNumericAlignment.Centered
      ? css`
          align-items: center;
          text-align: center;
        `
      : css`
          align-items: flex-start;
          text-align: left;
        `}
`;
